import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalHeader: {
    description: 'Header in modal to confirm connection to marketplace.',
    defaultMessage: 'Fulfillment Provider Connected',
    id: 'WcJWNy',
  },
  marketplaceConnectionConfirmation: {
    description: 'Message confirming the connection to the marketplace.',
    defaultMessage:
      '<b>{marketplaceName}</b> has been connected as a fulfillment provider to your account.  You may now begin delegating orders to them for fulfillment.',
    id: 'mw7Fc3',
  },
  automationRulesTip: {
    description: 'Tip explaining the functionality of automation rules.',
    defaultMessage:
      '<b>Tip:</b> You can create Automation Rules to automatically delegate some or all of your new orders to <b>{marketplaceName}</b>.',
    id: 'fwb2hG',
  },
  kbArticleLink: {
    description: 'Link to knowledge article with instructions on how to delegate orders.',
    defaultMessage: '<l>Click here</l> to learn how to delegate orders to your provider manually or using Automation Rules.',
    id: 'ndmgWS',
  },
  createAutomationButton: {
    description: 'button to create automation rules',
    defaultMessage: 'Create Automation Rules',
    id: '/n2i0p',
  },
  doneButton: {
    description: 'done button',
    defaultMessage: 'Done',
    id: 'YZ0edB',
  },
});

export default messages;
